/* CorePeptides — theme.js
   Real Shopify cart integration. No fake routing, no homepage redirects.
*/
(function () {
  'use strict';
  const $  = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const on = (el, ev, fn) => el && el.addEventListener(ev, fn);
  const money = (cents) => 'AED ' + (cents / 100).toFixed(2);

  /* ════════════════════════════════
     MOBILE MENU
  ════════════════════════════════ */
  const mBtn = $('#mobile-menu-btn'), mNav = $('#mobile-nav');
  on(mBtn, 'click', () => {
    const open = mNav.classList.toggle('open');
    mBtn.setAttribute('aria-expanded', String(open));
    mNav.setAttribute('aria-hidden', String(!open));
  });

  /* ════════════════════════════════
     CART BADGE — always reflects real Shopify cart
  ════════════════════════════════ */
  const badge = $('#cart-count');
  function setBadge(n) { if (badge) badge.textContent = n; }

  async function fetchCart() {
    const r = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    if (!r.ok) throw new Error('Cart fetch failed: ' + r.status);
    return r.json();
  }

  fetchCart().then(cart => setBadge(cart.item_count)).catch(() => {});

  /* ════════════════════════════════
     CART DRAWER
  ════════════════════════════════ */
  const overlay = $('#cart-overlay');
  const drawer  = $('#cart-drawer');
  const cdBody  = $('#cd-body');
  const cdSub   = $('#cd-subtotal');

  function openDrawer() {
    if (!overlay || !drawer) return;
    overlay.classList.add('open');
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    renderDrawer();
  }
  function closeDrawer() {
    if (!overlay || !drawer) return;
    overlay.classList.remove('open');
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
  }

  on($('#cart-open'), 'click', (e) => { e.preventDefault(); openDrawer(); });
  on($('#cart-close'), 'click', closeDrawer);
  on(overlay, 'click', closeDrawer);
  on(document, 'keydown', e => { if (e.key === 'Escape') closeDrawer(); });

  async function renderDrawer() {
    if (!cdBody) return;
    let cart;
    try { cart = await fetchCart(); }
    catch {
      cdBody.innerHTML = '<div class="cd-empty"><p>Unable to load cart. Please refresh.</p></div>';
      return;
    }
    setBadge(cart.item_count);
    if (cdSub) cdSub.textContent = money(cart.total_price);

    if (cart.item_count === 0) {
      cdBody.innerHTML = `<div class="cd-empty"><p>Your cart is empty.</p>
        <a href="/collections/all" style="color:#fff;font-size:.72rem;font-weight:700;letter-spacing:.14em;text-transform:uppercase;margin-top:12px;text-decoration:underline;display:inline-block">Continue Shopping</a></div>`;
      return;
    }

    cdBody.innerHTML = cart.items.map(item => `
      <div class="cd-item">
        <div class="cd-item-img">
          <img src="${window.__PEN_ASSET_URL__ || (item.image ? item.image.replace(/http:/g, 'https:') : '')}" alt="${item.product_title}" width="68" height="68" loading="lazy">
        </div>
        <div class="cd-item-info">
          <p class="cd-item-name">${item.product_title}</p>
          ${item.variant_title ? `<p class="cd-item-variant">${item.variant_title}</p>` : ''}
          <p class="cd-item-price">${money(item.final_price)}</p>
          <div class="cd-item-qty">
            <button data-line="${item.key}" data-q="${item.quantity - 1}">−</button>
            <span class="qty-n">${item.quantity}</span>
            <button data-line="${item.key}" data-q="${item.quantity + 1}">+</button>
            <span class="cd-rm" data-line="${item.key}" data-q="0">Remove</span>
          </div>
        </div>
      </div>`).join('');

    cdBody.querySelectorAll('[data-line]').forEach(el => {
      on(el, 'click', async () => {
        await changeCartLine(el.dataset.line, parseInt(el.dataset.q, 10));
        renderDrawer();
      });
    });
  }

  async function changeCartLine(lineKey, qty) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: qty })
      });
    } catch (err) {
      console.error('Cart change failed', err);
    }
  }

  /* ════════════════════════════════
     PRODUCT PAGE — FORMAT DROPDOWN VARIANT SELECTOR
  ════════════════════════════════ */
  function initVariantSelector() {
    const trigger   = $('#fmt-trigger');
    const list      = $('#fmt-list');
    const trigText  = $('#fmt-trigger-text');
    const trigPrice = $('#fmt-trigger-price');
    if (!trigger || !list) return;

    const select     = $('#pdp-variant-select');
    const priceEl    = $('#pdp-price');
    const formatEl   = $('#pdp-detail-format');
    const subtitleEl = $('#pdp-sub-text');
    const featFmt    = $('#feat-format');
    const atcBtn     = $('#pdp-atc-btn');
    const atcLabel   = $('#pdp-atc-label');
    const buyNowBtn  = $('#pdp-buy-now');

    // Gallery slide 0 image for variant image swapping
    const slide0Img = document.querySelector('#pgal-track .pgal-slide[data-index="0"] .pgal-img');

    let isOpen = false;

    function openDropdown() {
      isOpen = true;
      list.style.display = 'block';
      list.style.height = '0';
      list.style.overflow = 'hidden';
      list.removeAttribute('aria-hidden');
      trigger.setAttribute('aria-expanded', 'true');
      trigger.classList.add('fmt-trigger--open');
      const h = list.scrollHeight;
      list.style.transition = 'height 0.28s cubic-bezier(.22,.68,0,1)';
      requestAnimationFrame(() => { list.style.height = h + 'px'; });
    }

    function closeDropdown() {
      isOpen = false;
      list.style.transition = 'height 0.22s cubic-bezier(.22,.68,0,1)';
      list.style.height = '0';
      trigger.setAttribute('aria-expanded', 'false');
      trigger.classList.remove('fmt-trigger--open');
      list.setAttribute('aria-hidden', 'true');
      setTimeout(() => {
        if (!isOpen) { list.style.display = 'none'; list.style.height = ''; }
      }, 240);
    }

    on(trigger, 'click', () => isOpen ? closeDropdown() : openDropdown());

    // Close on outside click
    on(document, 'click', e => {
      if (isOpen && !e.target.closest('#fmt-drop')) closeDropdown();
    });

    // Close on Escape
    on(document, 'keydown', e => {
      if (e.key === 'Escape' && isOpen) closeDropdown();
    });

    // Option selection
    $$('.fmt-option').forEach(opt => {
      on(opt, 'click', () => {
        if (opt.dataset.soldOut) return;

        // Mark active
        $$('.fmt-option').forEach(o => {
          o.classList.remove('fmt-option--active');
          o.setAttribute('aria-selected', 'false');
        });
        opt.classList.add('fmt-option--active');
        opt.setAttribute('aria-selected', 'true');

        // Read data
        const vid       = opt.dataset.variantId;
        const price     = opt.dataset.variantPrice;
        const title     = opt.dataset.variantTitle;
        const available = opt.dataset.variantAvailable === 'true';
        const img       = opt.dataset.variantImage;
        const isVial    = opt.dataset.variantIsVial === 'true';
        const fmtLabel  = opt.dataset.variantFormat;

        // Update trigger display
        if (trigText)  trigText.textContent  = title;
        if (trigPrice) trigPrice.textContent = price + ' AED';

        // Close dropdown
        closeDropdown();

        // Update Shopify form hidden select
        if (select) select.value = vid;

        // Swap gallery image with fade
        if (slide0Img && img) {
          slide0Img.style.transition = 'opacity 0.2s ease';
          slide0Img.style.opacity = '0';
          setTimeout(() => {
            slide0Img.src = img;
            slide0Img.classList.toggle('pgal-img--vial', isVial);
            slide0Img.classList.toggle('pgal-img--pen',  !isVial);
            slide0Img.style.opacity = '1';
          }, 180);
        }

        // Update subtitle
        if (subtitleEl) {
          if (isVial) subtitleEl.textContent = 'RESEARCH PEPTIDE VIAL';
          else if (fmtLabel === 'Refill Cartridge') subtitleEl.textContent = 'RESEARCH PEPTIDE REFILL';
          else subtitleEl.textContent = 'RESEARCH PEPTIDE PEN';
        }

        // Update format feature bullet
        if (featFmt) {
          const tn = Array.from(featFmt.childNodes).find(n => n.nodeType === 3 && n.textContent.trim());
          if (tn) tn.textContent = fmtLabel;
        }

        // Price fade
        if (priceEl) {
          priceEl.style.transition = 'opacity 0.16s ease';
          priceEl.style.opacity = '0';
          setTimeout(() => { priceEl.textContent = price; priceEl.style.opacity = '1'; }, 140);
        }

        // Format detail row
        if (formatEl) formatEl.textContent = isVial ? title : title + ' per pen';

        // Availability
        if (atcBtn)     atcBtn.disabled     = !available;
        if (atcLabel)   atcLabel.textContent = available ? 'ADD TO CART' : 'SOLD OUT';
        if (buyNowBtn)  buyNowBtn.disabled   = !available;

        // Dose chart button — switch to correct tab for Retatrutide 60mg
        const doseBtn = document.querySelector('.pdp-dose-btn');
        if (doseBtn) {
          doseBtn.style.display = '';
          const titleLower = title.toLowerCase();
          const isRefill = titleLower.includes('refill') || titleLower.includes('cartridge');
          if (!isRefill && titleLower.includes('60')) {
            doseBtn.dataset.chartTab = '1'; // 60mg tab (index 1)
          } else {
            doseBtn.dataset.chartTab = '0'; // 30mg tab (index 0)
          }
        }
      });
    });
  }
  initVariantSelector();

  /* ════════════════════════════════
     PRODUCT IMAGE ZOOM
     Click/tap-to-open lightbox. Deliberately not hover-based,
     since hover zoom doesn't exist on touch devices — this pattern
     works identically on desktop, mobile, and iPad.
  ════════════════════════════════ */
  function initImageZoom() { /* replaced by initGallery below */ }
  initImageZoom();

  /* ════════════════════════════════
     PRODUCT IMAGE GALLERY
     Horizontal slider with:
     - Arrow buttons (desktop)
     - Touch swipe (mobile/iPad)
     - Dot navigation
     - Fullscreen lightbox on click
     - Zoom hint visible on slide 0 only
  ════════════════════════════════ */
  (function initGallery() {
    const track    = $('#pgal-track');
    const slides   = track ? $$('.pgal-slide', track) : [];
    const dots     = $$('.pgal-dot');
    const prevBtn  = $('#pgal-prev');
    const nextBtn  = $('#pgal-next');
    const zoomHint = $('#pgal-zoom-hint');
    const lb       = $('#pgal-lightbox');
    const lbImg    = $('#pgal-lb-img');
    const lbClose  = $('#pgal-lb-close');

    if (!track || slides.length === 0) return;

    let current = 0;
    const total = slides.length;

    function goTo(idx, animate = true) {
      // Clamp
      idx = Math.max(0, Math.min(total - 1, idx));
      if (idx === current && animate) return;

      // Fade out current, fade in next
      slides[current].classList.remove('pgal-slide--active');
      slides[idx].classList.add('pgal-slide--active');

      // Update dots
      dots.forEach((d, i) => d.classList.toggle('pgal-dot--active', i === idx));

      // Show/hide zoom hint (only on slide 0)
      if (zoomHint) zoomHint.style.opacity = idx === 0 ? '1' : '0';

      // Show/hide arrows at edges
      if (prevBtn) prevBtn.style.opacity = idx === 0 ? '0.3' : '1';
      if (nextBtn) nextBtn.style.opacity = idx === total - 1 ? '0.3' : '1';

      current = idx;
    }

    // Arrow clicks
    on(prevBtn, 'click', () => goTo(current - 1));
    on(nextBtn, 'click', () => goTo(current + 1));

    // Dot clicks
    dots.forEach(dot => on(dot, 'click', () => goTo(parseInt(dot.dataset.goto, 10))));

    // Touch/swipe
    let touchStartX = 0, touchStartY = 0, dragging = false;
    on(track, 'touchstart', e => {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      dragging = true;
    }, { passive: true });
    on(track, 'touchend', e => {
      if (!dragging) return;
      dragging = false;
      const dx = e.changedTouches[0].clientX - touchStartX;
      const dy = e.changedTouches[0].clientY - touchStartY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
        goTo(dx < 0 ? current + 1 : current - 1);
      }
    }, { passive: true });

    // Keyboard navigation
    on(document, 'keydown', e => {
      if (lb && lb.classList.contains('open')) return; // lightbox active
      if (e.key === 'ArrowLeft')  goTo(current - 1);
      if (e.key === 'ArrowRight') goTo(current + 1);
    });

    // Lightbox — clicking any slide image opens it fullscreen
    slides.forEach(slide => {
      const img = slide.querySelector('.pgal-img');
      if (!img || !lb || !lbImg) return;
      on(img, 'click', () => {
        lbImg.src = img.src;
        lbImg.alt = img.alt;
        lb.classList.add('open');
        lb.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });
    });
    function closeLb() {
      if (!lb) return;
      lb.classList.remove('open');
      lb.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    on(lbClose, 'click', closeLb);
    on(lb, 'click', e => { if (e.target === lb) closeLb(); });
    on(document, 'keydown', e => { if (e.key === 'Escape' && lb && lb.classList.contains('open')) closeLb(); });

    // Init state
    goTo(0, false);
  })();

  /* ════════════════════════════════
     THEME TOGGLE — dark / light
  ════════════════════════════════ */
  (function themeToggle() {
    const KEY = 'cp_theme';
    const btn = $('#theme-toggle');
    if (!btn) return;

    function applyTheme(mode) {
      if (mode === 'light') {
        document.documentElement.classList.add('light-mode');
        btn.setAttribute('aria-label', 'Switch to dark mode');
      } else {
        document.documentElement.classList.remove('light-mode');
        btn.setAttribute('aria-label', 'Switch to light mode');
      }
    }

    // Sync button label with what the pre-paint script already applied
    const saved = (() => { try { return localStorage.getItem(KEY); } catch(e) { return null; } })();
    applyTheme(saved === 'light' ? 'light' : 'dark');

    on(btn, 'click', () => {
      const isLight = document.documentElement.classList.toggle('light-mode');
      const next = isLight ? 'light' : 'dark';
      try { localStorage.setItem(KEY, next); } catch(e) {}
      applyTheme(next);
    });
  })();

  /* ════════════════════════════════
     DOSE CHART MODAL — HTML table, theme-aware
  ════════════════════════════════ */
  (function doseChart() {
    /* ── Dose Chart Data ── */
    var CHARTS = {
      reta: {
        title: 'Retatrutide Click-to-Dose Chart',
        defaultTab: 0,
        tabs: [
          {
            label: 'Retatrutide 30mg',
            cols: ['Clicks', 'Dose'],
            rows: [['8 clicks','1 mg'],['16 clicks','2 mg'],['24 clicks','3 mg'],
                   ['32 clicks','4 mg'],['40 clicks','5 mg'],['48 clicks','6 mg'],
                   ['56 clicks','7 mg'],['60 clicks','7.5 mg']]
          },
          {
            label: 'Retatrutide 60mg',
            cols: ['Clicks', 'Dose'],
            rows: [['8 clicks','2 mg'],['12 clicks','3 mg'],['16 clicks','4 mg'],
                   ['20 clicks','5 mg'],['24 clicks','6 mg'],['28 clicks','7 mg'],
                   ['32 clicks','8 mg'],['36 clicks','9 mg'],['40 clicks','10 mg'],
                   ['44 clicks','11 mg'],['48 clicks','12 mg'],['52 clicks','13 mg'],
                   ['56 clicks','14 mg'],['60 clicks','15 mg']]
          }
        ]
      },
      reta60: null,
      ghkcu: {
        title: 'GHK-Cu Click-to-Dose Chart',
        tabs: [
          {
            label: 'GHK-Cu 50mg',
            cols: ['Dose', 'Clicks'],
            rows: [['0.5 mg','3 clicks'],['1.0 mg','6 clicks'],['1.5 mg','9 clicks'],
                   ['2.0 mg','12 clicks'],['2.5 mg','15 clicks']]
          },
          {
            label: 'GHK-Cu 100mg',
            cols: ['Dose', 'Clicks'],
            rows: [['0.5 mg','2 clicks'],['1.0 mg','3 clicks'],['1.5 mg','5 clicks'],
                   ['2.0 mg','6 clicks'],['2.5 mg','8 clicks'],['3.0 mg','9 clicks'],
                   ['4.0 mg','12 clicks'],['5.0 mg','15 clicks']]
          }
        ]
      },
      motsc: {
        title: 'MOTS-C 40mg Click-to-Dose Chart',
        cols: ['Dose', 'Clicks'],
        rows: [['0.5 mg','3 clicks'],['1.0 mg','6 clicks'],['1.5 mg','9 clicks'],
               ['2.0 mg','12 clicks'],['2.5 mg','15 clicks'],['3.0 mg','18 clicks']]
      },
      melanotan: {
        title: 'Melanotan-1 10mg Click-to-Dose Chart',
        cols: ['Dose', 'Clicks'],
        rows: [['50 mcg','1 click'],['100 mcg','2 clicks'],['200 mcg','4 clicks'],
               ['300 mcg','6 clicks'],['400 mcg','8 clicks']]
      },
      cjc: {
        title: 'CJC-1295 No DAC + Ipamorelin Click-to-Dose Chart',
        cols: ['Dose (each)', 'Clicks'],
        rows: [['25 mcg + 25 mcg','1 click'],['100 mcg + 100 mcg','4 clicks'],
               ['150 mcg + 150 mcg','6 clicks'],['200 mcg + 200 mcg','8 clicks'],
               ['250 mcg + 250 mcg','10 clicks'],['300 mcg + 300 mcg','12 clicks']]
      },
      bpc: {
        title: 'BPC-157 + TB-500 Click-to-Dose Chart',
        cols: ['Dose (each)', 'Clicks'],
        rows: [['25 mcg + 25 mcg','1 click'],['100 mcg + 100 mcg','4 clicks'],
               ['200 mcg + 200 mcg','8 clicks'],['250 mcg + 250 mcg','10 clicks'],
               ['500 mcg + 500 mcg','20 clicks']]
      }
    };

    function buildTable(tab) {
      var h = tab.cols.map(function(c){return '<th>'+c+'</th>';}).join('');
      var b = tab.rows.map(function(r){
        return '<tr>'+r.map(function(c){return '<td>'+c+'</td>';}).join('')+'</tr>';
      }).join('');
      return '<table class="dc-table"><thead><tr>'+h+'</tr></thead><tbody>'+b+'</tbody></table>';
    }

    function buildTabbed(chart, startTab) {
      var activeIdx = startTab !== undefined ? startTab : 0;
      var tabBtns = chart.tabs.map(function(t, i) {
        return '<button class="dc-tab-btn'+(i===activeIdx?' dc-tab-btn--active':'')+'" data-tab="'+i+'">'+t.label+'</button>';
      }).join('');
      var panels = chart.tabs.map(function(t, i) {
        return '<div class="dc-tab-panel'+(i===activeIdx?' dc-tab-panel--active':'')+'" data-panel="'+i+'">'+buildTable(t)+'</div>';
      }).join('');
      return '<div class="dc-tabs"><div class="dc-tab-btns">'+tabBtns+'</div>'+panels+'</div>';
    }

    function openChart(key, startTab) {
      var chart  = CHARTS[key];
      var modal  = document.getElementById('dose-chart-modal');
      var titleEl= document.getElementById('dc-title');
      var bodyEl = document.getElementById('dc-body');
      if (!chart || !modal) return;
      if (titleEl) titleEl.textContent = chart.title;
      var tabIdx = (startTab !== undefined) ? startTab : (chart.defaultTab || 0);
      if (bodyEl)  bodyEl.innerHTML = chart.tabs ? buildTabbed(chart, tabIdx) : buildTable(chart);
      document.documentElement.setAttribute('data-modal-open', '');
      modal.style.display = 'flex';
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          modal.classList.add('open');
          modal.setAttribute('aria-hidden', 'false');
        });
      });
    }

    function closeChart() {
      var modal = document.getElementById('dose-chart-modal');
      if (!modal) return;
      modal.classList.remove('open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.removeAttribute('data-modal-open');
      setTimeout(function() {
        if (!modal.classList.contains('open')) modal.style.display = 'none';
      }, 220);
    }

    /* Tab switching — delegated */
    document.addEventListener('click', function(e) {
      /* Dose chart open */
      var btn = e.target.closest('.pdp-dose-btn');
      if (btn) { e.preventDefault(); openChart(btn.dataset.chart, btn.dataset.chartTab ? parseInt(btn.dataset.chartTab) : undefined); return; }

      /* Tab switch */
      var tabBtn = e.target.closest('.dc-tab-btn');
      if (tabBtn) {
        var idx = tabBtn.dataset.tab;
        var bodyEl = document.getElementById('dc-body');
        if (!bodyEl) return;
        bodyEl.querySelectorAll('.dc-tab-btn').forEach(function(b) { b.classList.remove('dc-tab-btn--active'); });
        bodyEl.querySelectorAll('.dc-tab-panel').forEach(function(p) { p.classList.remove('dc-tab-panel--active'); });
        tabBtn.classList.add('dc-tab-btn--active');
        var panel = bodyEl.querySelector('.dc-tab-panel[data-panel="'+idx+'"]');
        if (panel) panel.classList.add('dc-tab-panel--active');
        return;
      }

      /* Close */
      if (e.target.closest('#dc-close')) { closeChart(); return; }
      var modal = document.getElementById('dose-chart-modal');
      if (modal && modal.classList.contains('open') && e.target === modal) closeChart();
    });

    document.addEventListener('keydown', function(e) {
      if (e.key !== 'Escape') return;
      var modal = document.getElementById('dose-chart-modal');
      if (modal && modal.classList.contains('open')) closeChart();
    });
  })();

  /* ════════════════════════════════
     QUANTITY STEPPER
  ════════════════════════════════ */
  $$('.pdp-qbtn').forEach(btn => {
    on(btn, 'click', () => {
      const wrap = btn.closest('.pdp-qty');
      const inp = wrap ? wrap.querySelector('.pdp-qinp') : null;
      if (!inp) return;
      const next = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(btn.dataset.d, 10));
      inp.value = next;
    });
  });

  /* ════════════════════════════════
     ADD TO CART — real Shopify AJAX endpoint
     Includes optional 50 Needle Heads add-on (GHK-Cu page only)
  ════════════════════════════════ */

  /* ── Add-on checkbox UI ── */
  (function addonCheckbox() {
    const check = $('#addon-check');
    const box   = $('#addon-check-box');
    const card  = $('#addon-card');
    if (!check || !box) return;
    check.addEventListener('change', function() {
      const c = check.checked;
      box.innerHTML = c
        ? '<svg width="12" height="12" viewBox="0 0 16 16" fill="none" stroke="#000" stroke-width="2.5" stroke-linecap="round"><polyline points="2,8 6,12 14,4"/></svg>'
        : '';
      box.classList.toggle('addon-check-box--checked', c);
      if (card) card.classList.toggle('addon-card--selected', c);
    });
  })();

  /* Needle heads Shopify variant ID — read from the DOM so it's always live */
  function getNeedleVid() {
    /* Primary: data attribute injected by Liquid */
    const el = document.getElementById('addon-section');
    if (el && el.dataset.needleVid) return el.dataset.needleVid;
    return null;
  }

  async function addNeedleHeads() {
    /* Fallback: search cart for 50-needle-heads handle first to avoid dupes */
    const cartRes = await fetch('/cart.js');
    const cart    = await cartRes.json();
    const already = cart.items.some(i => i.handle === '50-needle-heads');
    if (already) return; /* don't add twice */

    /* Try variant ID from DOM first, then search by handle */
    let vid = getNeedleVid();
    if (!vid) {
      const prodRes = await fetch('/products/50-needle-heads.js');
      if (!prodRes.ok) throw new Error('Needle heads product not found');
      const prod = await prodRes.json();
      vid = prod.variants[0].id;
    }
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: vid, quantity: 1 })
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || 'Could not add needle heads');
    }
  }

  const pdpForm = $('#pdp-product-form');
  if (pdpForm) {
    on(pdpForm, 'submit', async (e) => {
      e.preventDefault();
      const btn   = $('#pdp-atc-btn');
      const label = $('#pdp-atc-label');
      if (!btn || btn.disabled) return;

      const addonCheck = $('#addon-check');
      const wantsAddon = addonCheck && addonCheck.checked;

      const orig = label ? label.textContent : '';
      btn.disabled = true;
      if (label) label.textContent = wantsAddon ? 'ADDING ITEMS…' : 'ADDING…';

      try {
        /* 1. Add main product */
        const formData = new FormData(pdpForm);
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        });
        if (!res.ok) {
          const errBody = await res.json().catch(() => ({}));
          throw new Error(errBody.description || 'Could not add to cart');
        }

        /* 2. Add needle heads if checked */
        if (wantsAddon) {
          await addNeedleHeads();
        }

        if (label) label.textContent = 'ADDED ✓';
        await renderDrawer();
        setTimeout(openDrawer, 250);
      } catch (err) {
        console.error('Add to cart failed:', err);
        if (label) label.textContent = 'ERROR — TRY AGAIN';
      } finally {
        setTimeout(() => {
          btn.disabled = false;
          if (label) label.textContent = orig;
        }, 2200);
      }
    });
  }

  /* ════════════════════════════════
     BUY NOW — adds then sends straight to Shopify checkout
  ════════════════════════════════ */
  const buyNowBtn = $('#pdp-buy-now');
  if (buyNowBtn) {
    on(buyNowBtn, 'click', async () => {
      if (buyNowBtn.disabled) return;
      const orig = buyNowBtn.textContent;
      buyNowBtn.disabled = true;
      buyNowBtn.textContent = 'PROCESSING…';

      try {
        const formData = new FormData(pdpForm);
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        });
        if (!res.ok) {
          const errBody = await res.json().catch(() => ({}));
          throw new Error(errBody.description || 'Could not add to cart');
        }
        window.location.href = '/checkout';
      } catch (err) {
        console.error('Buy now failed:', err);
        buyNowBtn.textContent = 'ERROR — TRY AGAIN';
        setTimeout(() => {
          buyNowBtn.disabled = false;
          buyNowBtn.textContent = orig;
        }, 2200);
      }
    });
  }

  /* ════════════════════════════════
     SCROLL — STICKY HEADER
  ════════════════════════════════ */
  const hdr = $('#site-header');
  on(window, 'scroll', () => {
    if (hdr) hdr.style.background = window.scrollY > 10 ? 'rgba(0,0,0,0.98)' : 'rgba(12,12,12,0.85)';
  }, { passive: true });

  /* ════════════════════════════════
     FADE-IN ON SCROLL
  ════════════════════════════════ */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e, i) => {
        if (!e.isIntersecting) return;
        setTimeout(() => {
          e.target.style.opacity = '1';
          e.target.style.transform = 'translateY(0)';
        }, i * 70);
        io.unobserve(e.target);
      });
    }, { threshold: 0.08 });

    $$('.feat, .pp-card, .pdp-feats li').forEach(el => {
      el.style.cssText += ';opacity:0;transform:translateY(14px);transition:opacity 0.55s ease,transform 0.55s ease';
      io.observe(el);
    });

    // About page reveal-on-scroll
    const apIo = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('in-view');
          apIo.unobserve(e.target);
        }
      });
    }, { threshold: 0.15 });
    $$('.ap-reveal').forEach(el => apIo.observe(el));
  }

  /* ════════════════════════════════
     ABOUT LINK — smart anchor scroll
     Works identically on desktop, mobile, and iPad.
     - If #about already exists on the current page, smooth-scroll to it.
     - If not (e.g. clicked from /collections/all or /products/x),
       the browser navigates to "/#about" and this same handler runs
       again after the new page loads, scrolling to it there.
     This guarantees About never silently bounces back to a blank
     homepage top — it always lands exactly on the About content.
  ════════════════════════════════ */
  function scrollToAboutIfPresent() {
    if (window.location.hash !== '#about') return;
    const target = document.getElementById('about');
    if (!target) return;
    // Defer slightly so layout/fonts/images have settled (important on mobile Safari/iPad)
    setTimeout(() => {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 80);
  }

  $$('.js-about-link').forEach(link => {
    on(link, 'click', (e) => {
      const targetOnPage = document.getElementById('about');
      if (targetOnPage) {
        // Already on a page that has #about — scroll directly, no page reload
        e.preventDefault();
        targetOnPage.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.pushState(null, '', '/#about');
        // Close mobile menu if open
        if (mNav && mNav.classList.contains('open')) {
          mNav.classList.remove('open');
          if (mBtn) mBtn.setAttribute('aria-expanded', 'false');
          mNav.setAttribute('aria-hidden', 'true');
        }
      }
      // Otherwise let the browser navigate normally to "/#about"
    });
  });

  // On initial page load, if URL already has #about (e.g. user followed
  // a link from another page), scroll to it once content is ready.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scrollToAboutIfPresent);
  } else {
    scrollToAboutIfPresent();
  }
  on(window, 'load', scrollToAboutIfPresent);

  /* ════════════════════════════════
     AGE VERIFICATION GATE
     - Blocks the site until confirmed (no X / no escape)
     - Stores confirmation 30 days via localStorage + cookie fallback
     - "Exit" redirects to Google
  ════════════════════════════════ */
  (function ageGate() {
    const STORAGE_KEY = 'cp_age_verified';
    const DAYS = 30;

    function setVerified() {
      try {
        if (window.localStorage) localStorage.setItem(STORAGE_KEY, '1');
      } catch (e) { /* localStorage unavailable (private mode etc.) — cookie still covers it */ }

      // Cookie fallback / cross-check, expires in 30 days
      const d = new Date();
      d.setTime(d.getTime() + DAYS * 24 * 60 * 60 * 1000);
      document.cookie = STORAGE_KEY + '=1; expires=' + d.toUTCString() + '; path=/; SameSite=Lax';
    }

    function isVerified() {
      try {
        if (window.localStorage && localStorage.getItem(STORAGE_KEY) === '1') return true;
      } catch (e) {}
      const match = document.cookie.match(/(?:^|; )cp_age_verified=([^;]*)/);
      return !!(match && match[1] === '1');
    }

    const gate = $('#age-gate');
    const wrap = $('#site-content-wrap');
    const confirmBtn = $('#age-gate-confirm');
    const exitBtn = $('#age-gate-exit');

    if (!gate) return;

    // Already verified within last 30 days — remove gate entirely, no flash.
    if (isVerified()) {
      gate.remove();
      document.documentElement.classList.remove('age-gate-pending');
      document.documentElement.classList.add('age-verified');
      if (wrap) { wrap.style.filter = 'none'; wrap.style.pointerEvents = 'auto'; }
      return;
    }

    // Not verified — keep page blurred/dimmed and inert until a choice is made.
    document.documentElement.classList.remove('age-verified');
    document.documentElement.classList.add('age-gate-pending');
    document.body.style.overflow = 'hidden'; // prevent background scroll while gated

    on(confirmBtn, 'click', () => {
      setVerified();
      gate.classList.add('age-gate-closing');
      if (wrap) wrap.classList.add('age-unlocking');
      document.documentElement.classList.remove('age-gate-pending');
      document.documentElement.classList.add('age-verified');
      document.body.style.overflow = '';
      setTimeout(() => gate.remove(), 480);
    });

    on(exitBtn, 'click', () => {
      window.location.href = 'https://www.google.com';
    });

    // No keyboard escape — block Esc from doing anything while gated
    on(document, 'keydown', (e) => {
      if (!document.documentElement.classList.contains('age-gate-pending')) return;
      if (e.key === 'Escape') e.preventDefault();
    });
  })();

  /* ════════════════════════════════
     WHATSAPP BACK-IN-STOCK NOTIFY ME
  ════════════════════════════════ */
  (function notifyMe() {
    var P = window.__NOTIFY_PRODUCT__;
    if (!P) return;

    var notifyBtn    = $('#pdp-notify-btn');
    var buyRow       = $('#pdp-buy-row');
    var buyNow       = $('#pdp-buy-now');
    var modal        = $('#notify-modal');
    var closeBtn     = $('#notify-close');
    var form         = $('#notify-form');
    var confirmDiv   = $('#notify-confirm');
    var confirmText  = $('#notify-confirm-text');
    var continueBtn  = $('#notify-continue');
    var phoneInput   = $('#notify-phone');
    var countryCode  = $('#notify-country-code');
    var consentCheck = $('#notify-consent');
    var consentLabel = $('#notify-consent-label');
    var consentBox   = $('#notify-consent-box');
    var phoneError   = $('#notify-phone-error');
    var consentError = $('#notify-consent-error');
    var submitBtn    = $('#notify-submit');
    var currentVid   = null;

    var DUPE_KEY = 'cp_notify_regs';
    function getRegs() { try { return JSON.parse(localStorage.getItem(DUPE_KEY)||'[]'); } catch(e){ return []; } }
    function addReg(vid,phone){ var r=getRegs(); r.push({vid:String(vid),phone:phone,ts:Date.now()}); try{localStorage.setItem(DUPE_KEY,JSON.stringify(r));}catch(e){} }
    function isDupe(vid,phone){ return getRegs().some(function(r){return r.vid===String(vid)&&r.phone===phone;}); }

    function normalisePhone(code,raw){
      var n=raw.replace(/[\s\-\(\)]/g,'');
      if(n.charAt(0)==='0') n=n.slice(1);
      if(!/^\d{7,14}$/.test(n)) return null;
      return code+n;
    }

    function updateSoldOutUI(available){
      if(!available){
        if(buyRow) buyRow.style.display='none';
        if(buyNow) buyNow.style.display='none';
        if(notifyBtn) notifyBtn.style.display='';
      } else {
        if(buyRow) buyRow.style.display='';
        if(buyNow) buyNow.style.display='';
        if(notifyBtn) notifyBtn.style.display='none';
      }
    }

    // Init from page-load variant
    var varSel = $('#pdp-variant-select');
    if(varSel){
      var initVid = parseInt(varSel.value);
      if(initVid && P.variantData[initVid]){
        currentVid=initVid;
        updateSoldOutUI(P.variantData[initVid].available);
      }
      varSel.addEventListener('change',function(){
        var vid=parseInt(varSel.value);
        if(P.variantData[vid]){ currentVid=vid; updateSoldOutUI(P.variantData[vid].available); }
      });
    }

    function showError(el,msg){if(el){el.textContent=msg;el.style.display='';}}
    function hideError(el){if(el){el.style.display='none';}}

    function openModal(){
      if(!modal) return;
      var vd = currentVid && P.variantData[currentVid];
      var img=$('#notify-product-img'), name=$('#notify-product-name'), vname=$('#notify-product-variant');
      if(img)   img.src=(vd&&vd.img)?vd.img:P.img;
      if(name)  name.textContent=P.title;
      if(vname) vname.textContent=vd?vd.title:'';
      var flds={'#notify-vid':currentVid||'','#notify-pid':P.id,'#notify-purl':P.url,'#notify-pname':P.title,'#notify-vname':vd?vd.title:''};
      Object.keys(flds).forEach(function(s){var el=$(s);if(el)el.value=flds[s];});
      if(form) form.style.display='';
      if(confirmDiv) confirmDiv.style.display='none';
      if(phoneInput) phoneInput.value='';
      if(consentCheck) consentCheck.checked=false;
      if(consentBox) consentBox.innerHTML='';
      if(consentLabel) consentLabel.classList.remove('notify-consent-wrap--checked');
      hideError(phoneError); hideError(consentError);
      modal.style.display='flex';
      document.documentElement.setAttribute('data-modal-open','');
      requestAnimationFrame(function(){requestAnimationFrame(function(){
        modal.classList.add('open');
        modal.setAttribute('aria-hidden','false');
        if(phoneInput) phoneInput.focus();
      });});
    }

    function closeModal(){
      if(!modal) return;
      modal.classList.remove('open');
      modal.setAttribute('aria-hidden','true');
      document.documentElement.removeAttribute('data-modal-open');
      setTimeout(function(){if(!modal.classList.contains('open'))modal.style.display='none';},220);
    }

    if(form){
      form.addEventListener('submit',function(e){
        e.preventDefault();
        var ok=true;
        var code=(countryCode?countryCode.value:'+971');
        var raw=(phoneInput?phoneInput.value.trim():'');
        var fullPhone=normalisePhone(code,raw);
        if(!fullPhone){showError(phoneError,'Please enter a valid phone number (7–14 digits).');ok=false;}else{hideError(phoneError);}
        if(!consentCheck||!consentCheck.checked){showError(consentError,'Please accept to continue.');ok=false;}else{hideError(consentError);}
        if(!ok) return;
        var vid=($('#notify-vid')||{}).value, pname=($('#notify-pname')||{}).value,
            vname=($('#notify-vname')||{}).value, purl=($('#notify-purl')||{}).value,
            pid=($('#notify-pid')||{}).value;
        if(isDupe(vid,fullPhone)){showError(phoneError,"You're already registered. We'll notify you when it's back.");return;}
        if(submitBtn){submitBtn.disabled=true;submitBtn.textContent='Registering…';}
        fetch('/apps/notify-restock',{method:'POST',headers:{'Content-Type':'application/json'},
          body:JSON.stringify({phone:fullPhone,product_id:pid,product_name:pname,variant_id:vid,variant_name:vname,product_url:purl,consent:true,registered_at:new Date().toISOString()})
        }).catch(function(){return {ok:false};}).then(function(){
          addReg(vid,fullPhone);
          try{var p=JSON.parse(localStorage.getItem('cp_notify_pending')||'[]');
            p.push({phone:fullPhone,product_id:pid,product_name:pname,variant_id:vid,variant_name:vname,product_url:purl,registered_at:new Date().toISOString()});
            localStorage.setItem('cp_notify_pending',JSON.stringify(p));}catch(e2){}
          if(form) form.style.display='none';
          if(confirmDiv) confirmDiv.style.display='';
          if(confirmText) confirmText.textContent='We\'ll notify you on WhatsApp when '+pname+(vname?' – '+vname:'')+' is available again.';
          if(submitBtn){submitBtn.disabled=false;}
        });
      });
    }

    if(consentCheck){
      consentCheck.addEventListener('change',function(){
        var c=consentCheck.checked;
        if(consentLabel) consentLabel.classList.toggle('notify-consent-wrap--checked',c);
        if(consentBox) consentBox.innerHTML=c?'<svg width="11" height="11" viewBox="0 0 16 16" fill="none" stroke="#000" stroke-width="2.5" stroke-linecap="round"><polyline points="2,8 6,12 14,4"/></svg>':'';
        if(c) hideError(consentError);
      });
    }
    if(phoneInput){ phoneInput.addEventListener('input',function(){ phoneInput.value=phoneInput.value.replace(/[^\d\s\-\(\)]/g,''); hideError(phoneError); }); }

    on(notifyBtn,'click',openModal);
    on(closeBtn,'click',closeModal);
    on(continueBtn,'click',closeModal);
    on(modal,'click',function(e){if(e.target===modal)closeModal();});
    on(document,'keydown',function(e){if(e.key==='Escape'&&modal&&modal.classList.contains('open'))closeModal();});
  })();

})();
